<template>
  <div>
    <v-expansion-panels flat class="my-2" accordion v-model="panel">
      <v-expansion-panel v-for="(item, id) in sekolah" :key="id" @click="onSelectSekolah(item, { id })">
        <v-expansion-panel-header class="py-0">
          <template v-slot:default="{ open }">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-list-item class="px-0">
                      <v-list-item-avatar color="blue">
                        <v-icon dark>mdi-office-building-outline</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="blue--text">
                          {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                        </div>
                        <div class="black--text body-2">
                          <span class="font-weight-medium">NPSN : </span>
                          {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title>
                          <v-label color="caption"><small>Informasi Laporan </small></v-label>
                        </v-list-item-title>
                        <div class="link black--text body-2">
                          <div v-if="$getDeepObj(item, `psp_kp_pa_sekolah_laporans.data.0.is_lengkap`) === 1">
                            <v-icon left color="success" small>mdi-checkbox-marked-circle</v-icon>
                            <strong>Semua</strong> Laporan sudah selesai
                          </div>
                          <div v-else-if="!$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.status_lengkap')">
                            <v-icon left color="red" small>mdi-alert</v-icon>
                            <span class="font-weight-medium">{{ isPeriodeEntry ? 'Semua' : '1' }}</span> Laporan belum
                            dikerjakan
                          </div>
                          <div v-else>
                            <v-icon left color="red" small>mdi-alert</v-icon>
                            Laporan belum lengkap
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title>
                          <v-label color="caption"><small>Status Laporan</small></v-label>
                        </v-list-item-title>
                        <v-list-item-subtitle class="link black--text body-2">
                          <v-chip
                            :color="
                              WARNA_STATUS[
                                $getDeepObj(item, `psp_kp_pa_sekolah_laporans.data.0.is_lengkap`) === 1
                                  ? 'selesai'
                                  : 'belum'
                              ]
                            "
                            dark
                            small
                          >
                            {{
                              $getDeepObj(item, `psp_kp_pa_sekolah_laporans.data.0.is_lengkap`) === 1
                                ? 'Sudah'
                                : 'Belum'
                            }}
                          </v-chip>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="blue--text">
                          {{ open ? 'Tampilkan Ringkas' : 'Tampilkan Semua' }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list class="orange lighten-5">
            <v-list-item>
              <v-list-item-content>
                <component
                  :is="isPeriodeEntry ? 'LaporanPmoPelaksanaan' : 'LaporanPmoRefleksi'"
                  :is-edit="isEdit && detail.meta && detail.meta.is_edit"
                  :is-login-ks="false"
                  :pendampingan-ke="kPertemuan"
                  :pelaksana="pelaksana"
                  :psp-kp-pa="pspKpPa"
                  :detail="detail.data"
                  :detail-meta="detail.meta"
                  :meta="detail.meta"
                  @reload="onSelectSekolah"
                />
              </v-list-item-content>
            </v-list-item>
            <v-divider class="my-4 mx-4" />
            <v-list-item>
              <v-list-item-content>
                <laporan-pmo-topik
                  :detail="detail.data"
                  :meta="detail.meta"
                  :pendampingan-ke="kPertemuan"
                  :pelaksana="Object.assign({}, pelaksana, { pendampingan_ke: mPendampinganPmo })"
                  :psp-kp-pa="pspKpPa"
                  :topiks-laporan="detail.laporan_topik || []"
                  :masters="Object.assign({}, masters, { 'topik-opsi': mProgresTopikOpsi, 'pic-opsi': mPicOpsi })"
                  :is-login-ks="false"
                  :is-edit="isEdit"
                  :is-periode-entry="isPeriodeEntry"
                  @reload="onSelectSekolah"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LaporanPmoPelaksanaan from '@views/gtk/laporan/pmo/components/LaporanPelaksanaan';
import LaporanPmoTopik from '@views/gtk/laporan/pmo/components/LaporanTopik';
import LaporanPmoRefleksi from '@views/gtk/laporan/pmo/components/LaporanRefleksi';

export default {
  name: 'DetailPmo2023',
  components: { LaporanPmoPelaksanaan, LaporanPmoTopik, LaporanPmoRefleksi },
  props: {
    sekolah: {
      type: Array,
      default: () => [],
    },
    dasars: {
      type: Object,
      default: () => {},
    },
    grup: {
      type: Object,
      default: () => {},
    },
    kPertemuan: {
      type: Number,
      required: true,
    },
    versi: {
      type: [Number, String],
      default: 2,
    },
    meta: {
      type: [Object, Array],
    },
    masters: {
      type: [Object],
    },
    current: {
      type: Object,
    },
    mPendampinganPmo: {
      type: Object,
    },
    pendampingan: {
      default: () => {},
    },
    pendampingans: {
      type: Object,
    },
  },
  data() {
    return {
      WARNA_STATUS: {
        tidak: 'orange',
        belum: 'error',
        proses: 'info',
        selesai: 'success',
      },
      panel: null,
      panelId: null,
      detail: { data: {}, meta: {} },
      mPicOpsi: [],
      formulir: {},
      pelaksana: {},
      pspKpPa: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      instansi: (state) => state.data?.instansi ?? {},
      configPendampingan: (state) => (state.data && state.data.pendampingan && state.data.pendampingan['kp-pa']) || {},
    }),

    ...mapState('diklatPa', {
      pics: (state) => (state && state.pics) || {},
    }),

    isBelumMulai() {
      return this.current['pendampingan_ke_pmo'] === 5 || this.kPertemuan < this.current['pendampingan_ke_pmo'];
    },

    isPeriodeEntry() {
      const periodeEntry = this.$getDeepObj(this.configPendampingan, 'pendampingan_ke-pmo-topik') || {};
      const periodeEntryAngkatan = periodeEntry[this.pendampingan.gelombang] || [];

      return periodeEntryAngkatan.includes(+this.kPertemuan);
    },

    isEdit() {
      return this.meta.is_edit && this.detail.meta && this.detail.meta.is_edit;
    },

    mProgresTopikOpsi() {
      return [
        { text: 'Selesai', value: 71 },
        { text: 'Dalam Proses', value: 72 },
        { text: 'Tertunda', value: 73 },
        { text: 'Dibatalkan', value: 74 },
      ];
    },
  },
  methods: {
    ...mapActions('diklatPa', ['getInstrument', 'getPic']),

    reset() {
      this.panel = null;
      this.panelId = null;
    },

    getBelumLengkapLaporan(item) {
      const statuslengkap = this.$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.status_lengkap') || {};
      const laporan = ['pmo', 'topik-1', 'topik-2'];

      return laporan.filter((lpr) => !statuslengkap[lpr]).length;
    },

    async onSelectSekolah(sekolah, { id, reset }) {
      const pspPelaksana = this.$getDeepObj(sekolah, 'psp_pelaksana.data') || {};
      const pspPelaksanaSekolah = this.$getDeepObj(sekolah, 'sekolah.data') || {};

      // pspKpPaPendampingan
      const pspKpPaPendampingans = (this.pendampingan.psp_kp_pa_pendampingans?.data ?? []).filter(
        (pendampingan) => +pendampingan.pendampingan_ke === +this.kPertemuan
      );
      const pspKpPaPendampingan = pspKpPaPendampingans[0] || {};

      // pendampingan_id dan sekolah_id
      const kpPaPendampinganId = pspKpPaPendampingan.psp_kp_pa_pendampingan_id || '';
      const kpPaSekolahId = sekolah.psp_kp_pa_sekolah_id || '';

      // get pic
      await this.getPic({ id: kpPaPendampinganId, sekolah_id: kpPaSekolahId });
      const opsi = this.$getDeepObj(this.pics, `${kpPaPendampinganId}-${kpPaSekolahId}`) || [];

      this.mPicOpsi = opsi.map((pic) => {
        return {
          text: pic.nama,
          value: pic.ptk_id,
        };
      });

      this.pelaksana = Object.assign(pspPelaksana, { sekolah: pspPelaksanaSekolah });
      this.detail = {
        data: {},
        meta: {
          psp_kp_pa_pendampingan: pspKpPaPendampingan,
          pelaksana: Object.assign(pspPelaksana, { sekolah: pspPelaksanaSekolah }),
          pendampingan_ke: this.mPendampinganPmo,
          psp_kp_pa_pendampingan_id: kpPaPendampinganId,
          psp_kp_pa_sekolah_id: kpPaSekolahId,
          sekolah: sekolah,
          laporan_topik: {},
        },
      };

      if (this.panelId === id && !reset) {
        this.panelId = null;
        return;
      }

      if (reset) {
        this.$emit('reload', this.kPertemuan);
      }

      // get detail laporan sekolah
      const resp = await this.getInstrument({ id: kpPaPendampinganId, sekolah_id: kpPaSekolahId });

      this.pspKpPa = this.$getDeepObj(resp, 'data.psp_kp_pa_pendampingan.data.psp_kp_pa.data') || {};
      this.detail.data = Object.assign({}, this.detail.data, resp.data || {});
      this.detail.meta = Object.assign({}, this.detail.meta, resp.meta || {});

      if (!reset) {
        this.panelId = id;
      }

      if (!resp) {
        this.panel = null;
      }
    },

    onKuisioner(item, grup, dasarKe) {
      this.$emit('onKuisioner', { data: item, grup, dasarKe, isEditSaran: this.isEditSaran(item, grup) });
    },

    onChangePanel(panelId) {
      if (this.panelId && !panelId) {
        this.panelId = null;
      }
    },
  },
  watch: {
    panel: 'onChangePanel',
  },
};
</script>

<style scoped></style>
